module.exports = __webpack_public_path__ + "static/hero-top-2-sp-6144ad0bbdf70c8a8c35a9307099712c.png";